import { useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

/**
 * @description Hooks an axios error interceptor for your react application
 */
const useErrorHandler = () => {
  const errorInterceptor = axios.interceptors.response.use(
    (res) => res,
    (error) => {
      if (error?.response?.status) {
        switch (error.response.status) {
          case 401:
            Swal.fire({
              icon: "error",
              title: "로그인 실패",
              target: document.getElementById("main"),
              text: "로그인 정보를 다시 확인 하세요",
              confirmButtonColor: "#1e90ff",
            });
            throw error;
          case 406:
            if (error.response.data.state === 13) {
              Swal.fire({
                icon: "error",
                title: "로그인실패",
                target: document.getElementById("main"),
                text: "관리자 승인이 필요합니다",
                confirmButtonColor: "#1e90ff",
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "세션만료",
                target: document.getElementById("main"),
                text: "재로그인이 필요합니다",
                confirmButtonColor: "#1e90ff",
              });
              window.sessionStorage.clear();
              window.location.replace("/login/userlogin");
            }
            // Actions for Error 401
            throw error;
          case 500:
            // Actions for Error 500
            throw error;
          default:
            console.error("from hook interceptor => ", error);
            throw error;
        }
      } else {
        // Occurs for axios error.message = 'Network Error'
        throw error;
      }
    }
  );

  useEffect(() => {
    return () => {
      axios.interceptors.response.eject(errorInterceptor);
    };
  });
};

export default useErrorHandler;
